/**
 * Map buy- vs sell-aggressor share imbalance to a fill color for chart markers.
 * Uses only classified B + A volume for the signed axis (neutral does not shift hue).
 */

const DEAD_ZONE = 0.06;

/** In [-1, 1]: +1 = all buy, -1 = all sell, 0 = balanced (B vs A only). */
export function tapeImbalanceSignedRatio(buyShares: number, sellShares: number): number {
  const denom = buyShares + sellShares;
  if (denom <= 0) return 0;
  return (buyShares - sellShares) / denom;
}

/**
 * Red (sell-heavy) → gray (balanced) → green (buy-heavy).
 * Hue runs 0°–120° via HSL; saturation scales with strength.
 */
export function tapeImbalanceDotFill(signed: number): string {
  const t = Math.max(-1, Math.min(1, signed));
  if (Math.abs(t) < DEAD_ZONE) {
    return '#94a3b8';
  }
  const hue = 60 * (t + 1);
  const sat = 42 + Math.abs(t) * 48;
  const light = 48;
  return `hsl(${hue.toFixed(1)}, ${sat.toFixed(1)}%, ${light}%)`;
}
